/**
 * The checkbox in front of an activity: ticking it marks the activity done,
 * unticking marks it not done.
 *
 * It presses the `done` / `undone` action from `useActivityActions` rather
 * than calling the API itself, so the permission, the pending state and the
 * failure report are the action's — the same as the row icon would give.
 */
import Checkbox from '@mui/material/Checkbox';
import type { ActivityDto } from '@forsys/shared';
import type { EntityAction } from '../../components/RowActions';

export function ActivityDoneCheckbox({
  activity,
  rowActions,
}: {
  activity: ActivityDto;
  /** `useActivityActions(...).rowActions`. */
  rowActions: (activity: ActivityDto) => readonly EntityAction[];
}) {
  const done = activity.doneAt !== null;
  const toggle = rowActions(activity).find((action) => action.key === (done ? 'undone' : 'done'));
  return (
    <Checkbox
      size="small"
      checked={done}
      disabled={!toggle || toggle.disabled === true}
      onChange={() => toggle?.onClick()}
      slotProps={{ input: { 'aria-label': toggle?.label ?? '' } }}
    />
  );
}
